export default __webpack_public_path__ + "static/media/s2-hero.69a6aa78.jpg";